import {
	ApplicationConfig,
	ErrorHandler,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
	isDevMode,
	inject,
	LOCALE_ID,
	Provider
} from '@angular/core';
import {provideRouter,withInMemoryScrolling,withPreloading,withRouterConfig} from '@angular/router';
import {routes} from './app.routes';
import {provideClientHydration,withIncrementalHydration,withI18nSupport} from '@angular/platform-browser';
import {provideServiceWorker} from '@angular/service-worker';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {MAT_DATE_FORMATS,MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {provideHttpClient,withFetch,withInterceptors} from '@angular/common/http';
import {AppService} from './app.service';
import {
	provideNgxWebstorage,
	withLocalStorage,
	withNgxWebstorageConfig
} from 'ngx-webstorage';
import {SelectivePreloadingStrategyService} from './common/selective-preloading-strategy.service';
import {GlobalErrorHandler} from './common/global-error-handler.service';
import {httpErrorInterceptor} from './common/http-error.interceptor';
import {provideFirebase} from './common/firebase/firebase.providers';
import {provideConsentTracking} from './common/consent/consent.providers';
import {provideGalleryOptions} from 'ng-gallery';

const appDefaultOptions:Provider[]=[
	{provide:MAT_DATE_LOCALE,useFactory:()=>inject(LOCALE_ID)==='es' ? 'es-CO' : 'en-US'},
	{
		provide:MAT_DATE_FORMATS,
		useValue:{
			parse:{
				dateInput:['l','LL']
			},
			display:{
				dateInput:'L',
				monthYearLabel:'MMM YYYY',
				dateA11yLabel:'LL',
				monthYearA11yLabel:'MMMM YYYY'
			}
		}
	},
	{
		provide:MAT_DIALOG_DEFAULT_OPTIONS,
		useValue:{
			disableClose:true,
			hasBackdrop:true,
			autoFocus:'first-tabbable'
		}
	},
	{
		provide:MAT_SNACK_BAR_DEFAULT_OPTIONS,
		useValue:{
			duration:3000,
			horizontalPosition:'center',
			verticalPosition:'top'
		}
	}
];

export const appConfig:ApplicationConfig={
	providers:[
		{provide:ErrorHandler,useClass:GlobalErrorHandler},
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			routes,
			withPreloading(SelectivePreloadingStrategyService),
			withRouterConfig({canceledNavigationResolution:'computed'}),
			withInMemoryScrolling({scrollPositionRestoration:'enabled'})
		),
		provideClientHydration(withIncrementalHydration(),withI18nSupport()),
		provideServiceWorker('ngsw-worker.js',{
			enabled:!isDevMode(),
			registrationStrategy:'registerWhenStable:30000'
		}),
		provideAnimationsAsync(),
		provideNgxWebstorage(
			withNgxWebstorageConfig({separator:'app',caseSensitive:true}),
			withLocalStorage()
		),
		provideFirebase(),
		provideConsentTracking(),
		provideHttpClient(withFetch(),withInterceptors([httpErrorInterceptor])),
		AppService,
		// ng-gallery 13 made thumbs, counter and navigation declarative components rather than
		// boolean options: `thumb`/`counter`/`dots` no longer exist, and the index template renders
		// none of `<gallery-thumbs>`/`<gallery-counter>`/`<gallery-nav>`, which is the same result.
		provideGalleryOptions({loop:true,autoplay:true,autoplayInterval:10*1000}),
		...appDefaultOptions
	]
};
